import * as Types from "../constants/actionTypes";

export const insertVP = (vp) => (dispatch) => {
  dispatch({
    type: Types.USER_VIEW,
    payload: { vp },
  });
};
